import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["description"]

  connect() {
    // Store the original classes for restoration
    this.originalClasses = this.descriptionTarget?.className || ""
  }

  expand() {
    if (this.hasDescriptionTarget) {
      this.descriptionTarget.classList.remove("line-clamp-2")
      this.descriptionTarget.classList.add("transition-all", "duration-200")
    }
  }

  collapse() {
    if (this.hasDescriptionTarget) {
      this.descriptionTarget.classList.add("line-clamp-2")
      this.descriptionTarget.classList.add("transition-all", "duration-200")
    }
  }
}
